import { useRecoilState } from "recoil";
import { attendanceFilterState } from "../../utils/atoms/atoms";

const AttendanceSearchBar = () => {
  const [globalFilter, setGlobalFilter] = useRecoilState(attendanceFilterState);

  return (
    <input
      type="text"
      className="search-attd"
      placeholder="Search employees"
      value={globalFilter}
      onChange={(e) => setGlobalFilter(String(e.target.value))}
    />
  );
};

export default AttendanceSearchBar;
